import { breakpoints } from '@theme/breakpoints';
import { css } from 'styled-components';

export const reviewHeadingStyles = css`
  color: var(--colors-primary-bright);
  font-size: 1.75rem;
  line-height: 1.1;
  font-weight: 500;
  max-width: 20rem;
  margin: 2.5rem auto;

  @media ${breakpoints.tablet} {
    font-size: 2.5rem;
    max-width: unset;
  }

  & + .trustpilot-widget {
    margin-bottom: 2.5rem;
  }
`;
